import { Check, Compass, Heart, HeartHandshake, LockKeyhole, MessageCircle, Shield, User } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export const BRAND_ASSETS = {
  markLight: "/brand/yara-mark-on-light.svg",
  markDark: "/brand/yara-mark-on-dark.svg",
  sidebarWordmarkLight: "/brand/yara-wordmark-transparent-on-light.png",
  sidebarWordmarkDark: "/brand/yara-wordmark-transparent-on-dark.png",
} as const;

export const MATCH_HOW_IT_WORKS = [
  {
    title: "Complete your profile",
    body: "Add photos and fill out your details so we can find compatible matches.",
    icon: User,
    tone: "profile",
  },
  {
    title: "Get matched",
    body: "Yara introduces one compatible person at a time—no feed to swipe.",
    icon: Compass,
    tone: "match",
  },
  {
    title: "Review and connect",
    body: "Answer privately. Chat opens only if you both accept.",
    icon: HeartHandshake,
    tone: "respond",
  },
] as const;

export const ONBOARDING_WIZARD_STEPS = [
  { id: "profile", label: "Profile", hint: "Photos and details" },
  { id: "preferences", label: "Preferences", hint: "Who to meet" },
  { id: "match", label: "Match", hint: "Your introductions" },
] as const;

export const CONNECTED_MESSAGES = [
  (name: string) => `Say hi to ${name}`,
  (name: string) => `${name} is waiting to hear from you`,
  (name: string) => `Start a conversation with ${name}`,
  (name: string) => `Get to know ${name}`,
  (name: string) => `Send ${name} a message`,
] as const;

export type AppStepTone = "invite" | "profile" | "match" | "respond" | "chat";

export type AppStep = {
  title: string;
  body: string;
  icon: LucideIcon;
  tone?: AppStepTone;
};

export const APP_HOW_YARA_WORKS: AppStep[] = [
  {
    title: "Invite-Only Community",
    body: "Members invite trusted people, helping Yara stay safer, warmer, and more intentional.",
    icon: Shield,
    tone: "invite",
  },
  {
    title: "Create Your Profile",
    body: "Share your values, interests, photos, and what you are hoping to build with someone.",
    icon: User,
    tone: "profile",
  },
  {
    title: "Thoughtful Matching",
    body: "Yara introduces one potential match at a time, so each person gets real attention.",
    icon: Heart,
    tone: "match",
  },
  {
    title: "Private Choice",
    body: "Answer privately. A no stays quiet; chat opens only if both people choose yes.",
    icon: Check,
    tone: "respond",
  },
  {
    title: "Meaningful Conversations",
    body: "Once connected, full profiles and private chat help you get to know each other.",
    icon: MessageCircle,
    tone: "chat",
  },
];

export const MIN_PHOTOS_HINT = 3;
